import { SLASH } from "~/shared/str";

const BASE_URL = "admin";

const URLS = {
  getOrderStatistics: [BASE_URL, "infographics"].join(SLASH),
  sendEmail: [BASE_URL, "send-email"].join(SLASH),
  getRevenueForYear: [BASE_URL, "revenueChartData"].join(SLASH),
  getCreationDateOfFirstOrder: [BASE_URL, "first-order-date"].join(SLASH),
};

export { URLS };
